import LoadingIndicatorDirective from './loading-indicator.directive';
import TabIndexDirective from './tabindex.directive';

// Base Directive Modul
angular
	.module('app.directives', [])
	.directive('wcoLoadingIndicator', LoadingIndicatorDirective)
	.directive('wcoTabindex', TabIndexDirective);
